export const GRID_NAMES = {
  UNDERWRITER_GRID: 1,
  CLIENT_GRID_OPEN: 2,
  CLIENT_GRID_CLOSED: 3,
  CLIENT_GRID: 4,
};
